import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import './App.css';
import About from "./Components/About";
import Check from "./Components/Check";
import Contact from "./Components/Contact";
import Create from "./Components/Create";
import Home from './Components/Home';
import Navbar from "./Components/Navbar";
import DotRing from "./Components/DotRing";
import Portfolio from "./Components/Portfolio";
import Skills from "./Components/Skills";
import { Helmet } from "react-helmet";

function App() {

  return (
    <main>
      <Helmet>

        <title>Shyam's Portfolio</title>
        <meta name="description" content="Portfolio web site created by Shyam Sundar B, web and android app developer. 
A student of SASTRA Deemed to be University." />
        <meta name="google-site-verification" content="4fimjNvHrmwKiMb4b-JsAqv2ltAcEKEuQ7dYs4YCPqo" />
        <meta itemprop="name" content="Shyam's Portfolio" />
        <meta itemprop="description" content="Portfolio web site created by Shyam Sundar B, web and android app developer. 
A student of SASTRA Deemed to be University." />
        <meta itemprop="image" content="https://shyam-sundar-b.web.app/shyam-sundar-b.png" />

        <meta property="og:url" content="https://shyam-sundar-b.web.app/" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Shyam's Portfolio" />
        <meta property="og:description" content="Portfolio web site created by Shyam Sundar B, web and android app developer.
A student of SASTRA Deemed to be University." />
        <meta property="og:image" content="https://shyam-sundar-b.web.app/shyam-sundar-b.png" />


        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Shyam's Portfolio" />
        <meta name="twitter:description" content="Portfolio web site created by Shyam Sundar B, web and android app developer.
A student of SASTRA Deemed to be University." />
        <meta name="twitter:image" content="https://shyam-sundar-b.web.app/shyam-sundar-b.png" />

      </Helmet>
      <Router>
        <DotRing />
        <Switch className="content__body">
          <Route path="/skills" exact component={Skills} />
          <Route path="/about" exact component={About} />
          <Route path="#hash" exact component={Portfolio} />
          <Route path="/contact" exact component={Contact} />
          <Route path="/con" exact component={Check} />
          <Route path='/' component={Home} />
        </Switch>
      </Router>
    </main>
  );
}

export default App;
